import httpRequest from "@/services/httpRequest"

export default ({
  namespaced: true,
  state: {
    isLoading: false,
    events: [],
    eventTypes: [],
    semesterSummary: {},
    errorMessage: null,
  },
  getters: {},
  mutations: {
    // --- Status Loading dan Error ---
    SET_LOADING_STATUS(state, status) {
      state.isLoading = status;
    },
    SET_ERROR_MESSAGE(state, message) {
      state.errorMessage = message;
    },
    CLEAR_ERROR_MESSAGE(state) {
      state.errorMessage = null;
    },

    // --- Data ---
    SET_EVENTS(state, events) {
      state.events = events;
    },
    SET_EVENT_TYPES(state, eventTypes) {
      state.eventTypes = eventTypes;
    },
    SET_SEMESTER_SUMMARY(state, summary) {
      state.semesterSummary = summary;
    },
  },
  actions: {

    /**
    * Mengambil daftar events dari API.
    * Memperbarui state.events, state.isLoading, dan state.errorMessage.
    * @param {Object} context - Objek konteks Vuex (commit, rootState)
    * @param {Object} params - Parameter query untuk permintaan API (contoh: start_date, end_date, is_holiday, is_effective_day, classroom.)
    */
    async getEvents({ rootState, commit }, params) {
      commit("SET_LOADING_STATUS", true);
      commit("CLEAR_ERROR_MESSAGE");
      try {
        const payload = {
          options: {
            url: `${rootState.baseURL}/api/events`,
            method: 'GET',
            params: params,
          },
          authorized: true
        };
        const response = await httpRequest(payload);

        if (response.status === 200) {
          const eventsData = response.data?.results || [];
          commit("SET_EVENTS", eventsData);
          // console.log('Events berhasil diambil:', eventsData);
        } else {
          const errorMessage = `Gagal mengambil Events: ${response.status} - ${response.statusText || 'Terjadi kesalahan'}`;
          commit("SET_ERROR_MESSAGE", errorMessage);
          // console.error(errorMessage, response);
        }
      } catch (error) {
        const errorMessage = `Terjadi kesalahan jaringan saat mengambil Events: ${error.message}`;
        commit("SET_ERROR_MESSAGE", errorMessage);
        // console.error(errorMessage, error);
      } finally {
        commit("SET_LOADING_STATUS", false);
      }
    },

    /**
    * Mengambil daftar event types dari API.
    * Memperbarui state.eventTypes, state.isLoading, dan state.errorMessage.
    * @param {Object} context - Objek konteks Vuex (commit, rootState)
    */
    async getEventTypes({ rootState, commit }) {
      commit("SET_LOADING_STATUS", true);
      commit("CLEAR_ERROR_MESSAGE");
      try {
        const payload = {
          options: {
            url: `${rootState.baseURL}/api/eventypes`,
            method: 'GET',
          },
          authorized: true
        };
        const response = await httpRequest(payload);

        if (response.status === 200) {
          const eventTypesData = response.data?.results || [];
          commit("SET_EVENT_TYPES", eventTypesData);
          // console.log('Event Types berhasil diambil:', eventTypesData);
        } else {
          const errorMessage = `Gagal mengambil Event Types: ${response.status} - ${response.statusText || 'Terjadi kesalahan'}`;
          commit("SET_ERROR_MESSAGE", errorMessage);
          // console.error(errorMessage, response);
        }
      } catch (error) {
        const errorMessage = `Terjadi kesalahan jaringan saat mengambil Event Types: ${error.message}`;
        commit("SET_ERROR_MESSAGE", errorMessage);
        // console.error(errorMessage, error);
      } finally {
        commit("SET_LOADING_STATUS", false);
      }
    },
    /**
     * Mengambil Ringkasan akademik kalender tiap semester dari API.
     * Memperbarui state.semesterSummary, state.isLoading, dan state.errorMessage.
     * @param {Object} context - Objek konteks Vuex (commit, rootState, state)
     * @param {number|string} semesterId - ID semester yang akan diambil ringkasannya
     */
    async getSemesterSummary({ commit, rootState }, semesterId) {
      commit("SET_LOADING_STATUS", true);
      commit("CLEAR_ERROR_MESSAGE");
      try {
        const payload = {
          options: {
            url: `${rootState.baseURL}/api/semestersummary/${semesterId}`,
            method: 'GET',
          },
          authorized: true
        };
        const response = await httpRequest(payload);

        if (response.status === 200) {
          const summaryData = response.data || {};
          commit("SET_SEMESTER_SUMMARY", summaryData);
          // console.log('Ringkasan Semester berhasil diambil:', summaryData);
        } else {
          const errorMessage = `Gagal mengambil Ringkasan Semester: ${response.status} - ${response.statusText || 'Terjadi kesalahan'}`;
          commit("SET_ERROR_MESSAGE", errorMessage);
          // console.error(errorMessage, response);
        }
      } catch (error) {
        const errorMessage = `Terjadi kesalahan jaringan saat mengambil Ringkasan Semester: ${error.message}`;
        commit("SET_ERROR_MESSAGE", errorMessage);
        // console.error(errorMessage, error);
      } finally {
        commit("SET_LOADING_STATUS", false);
      }
    },
  },
});